import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import { getIcon } from 'features/Project/components/Wizards/utils'
import { AreaTools, AreaSelection } from 'models/editor'
import { PointDescription } from './components/PointDescription'
import { PolygonDescription } from './components/PolygonDescription'
import { TrafficDescription } from './components/TrafficDescription'
import { Flex } from 'components/Flex'
import { Feature, FeatureOf, Point } from 'models/map'
import { RadiusDescription } from './components/RadiusDescription'
import { MobilityReportDescription } from './components/MobilityReportDescription'
import { useMapEditorContext } from 'context/map-editor-context'
import styles from './Confirmation.module.scss'
import { PredictiveReportDescription } from './components/PredictiveReportDescription'

const description = (areaTool: AreaSelection, selectedFeature: Feature) => {
  switch (areaTool) {
    case AreaTools.POINT:
      return <PointDescription selectedFeature={selectedFeature as FeatureOf<Point>} />
    case AreaTools.POINT_PONDERA:
      return <PointDescription selectedFeature={selectedFeature as FeatureOf<Point>} />
    case AreaTools.POLYGON:
      return <PolygonDescription selectedFeature={selectedFeature} />
    case AreaTools.RADIUS:
      return <RadiusDescription selectedFeature={selectedFeature} />
    case AreaTools.TRAFFIC_TOOL:
      return <TrafficDescription />
    case AreaTools.MOBILITY_REPORT_TOOL:
      return <MobilityReportDescription />
    case AreaTools.PREDICTIVE_REPORT_TOOL:
      return <PredictiveReportDescription />
  }
}

type ConfirmationProps = {
  onConfirm: () => void
}

export const Confirmation: FC<ConfirmationProps> = ({ onConfirm }) => {
  const { t } = useTranslation()
  const [{ wizard, editor, areaTool, editingLayer }, mapEditorDispatch] = useMapEditorContext()
  const selectedFeature = editor.feature

  return (
    <Flex justify="between" align="center" gap="md" className={styles.confirmation}>
      <Flex justify="center" align="center" className={styles.iconContainer}>
        {getIcon(areaTool)}
      </Flex>
      <div>
        <Text className={styles.title} weight="strong">
          {t(`confirmation_banner.${wizard}.${areaTool}.title`, { layerName: editingLayer?.name })}
        </Text>

        {selectedFeature ? (
          description(areaTool, selectedFeature)
        ) : (
          <Text>{t(`confirmation_banner.${wizard}.${areaTool}.click_on_map`)}</Text>
        )}
      </div>
      <Flex gap="sm">
        <Button onClick={onConfirm} disabled={!selectedFeature}>
          {t(`confirmation_banner.${wizard}.${areaTool}.cta`)}
        </Button>
        <Button onClick={mapEditorDispatch.cancelWizard} variant="danger">
          {t('confirmation_banner.cancel')}
        </Button>
      </Flex>
    </Flex>
  )
}

Confirmation.displayName = 'Confirmation'
